const NOT_FOUND = 'not found'

const SOMETHING_WENT_WRONG = 'Something went wrong'

const PLATFORM = {
  ANDROID: 'android',
  WEB: 'web',
  IOS: 'ios',
}

const OFFICE_ADDRESS =
  '8, 20th Main Rd, KHB Colony, Koramangala Industrial Layout, Koramangala, Bengaluru, Karnataka 560034, India'

// pass order id
const IN_APP_PURCHASE_DEEPLINK =
  'pocketfm://open?entity_type=coin_wallet&entity_id=external_inapp'

const APPS_FLYER_BASE = 'https://pocketfm.onelink.me/2IE7'

const PUBLIC_IMAGES = {
  POCKET_FM_LOGO: '/images/pocket_fm_logo_square.webp',
}

export {
  APPS_FLYER_BASE,
  NOT_FOUND,
  SOMETHING_WENT_WRONG,
  PLATFORM,
  PUBLIC_IMAGES,
  OFFICE_ADDRESS,
  IN_APP_PURCHASE_DEEPLINK,
}
